import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { optimizeImage } from '../utils/imageOptimizer';
import './AboutSection.css';

const about1 = 'https://caninecrown.ascentbw.com/Image/Home/Abt1.jpeg';
const about2 = 'https://caninecrown.ascentbw.com/Image/Home/Abt2.jpeg';
const about3 = 'https://caninecrown.ascentbw.com/Image/Home/Abt3.jpeg';
const about4 = 'https://caninecrown.ascentbw.com/Image/Home/Abt4.jpeg';

const AboutSection = () => {
  const sectionRef = useRef(null);
  const img1Ref = useRef(null);
  const img2Ref = useRef(null);
  const img3Ref = useRef(null);
  const img4Ref = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (!sectionRef.current) return;

      const section = sectionRef.current;
      const rect = section.getBoundingClientRect();
      const viewportHeight = window.innerHeight;

      // Section top hits viewport top (0) -> Animation starts
      // Section bottom hits viewport bottom -> Animation ends
      const sectionTop = rect.top;
      const sectionHeight = rect.height;

      // Calculate progress of scroll through the section (from 0 to 1)
      // When top is 0, progress should be 0.
      // When top is -(sectionHeight - viewportHeight), progress should be 1.
      const scrollDist = sectionHeight - viewportHeight;
      let rawProgress = -sectionTop / scrollDist;
      let progress = Math.max(0, Math.min(1, rawProgress));

      const setTransform = (ref, xMult, yMult, rotation) => {
        if (ref.current) {
          // Progress 0: translate(-50%, -50%)
          // Progress 1: translate(-50% ± maxScatter, -50% ± maxScatter)
          const scatterX = xMult * progress * 130; // Reduced from 150
          const scatterY = yMult * progress * 90; // Reduced from 120
          
          const baseRotation = rotation * (0.8 + 0.2 * progress);
          
          ref.current.style.transform = `translate(calc(-50% + ${scatterX}%), calc(-50% + ${scatterY}%) ) rotate(${baseRotation}deg)`;
        }
      };

      // Directions: Top-Left, Top-Right, Bottom-Left, Bottom-Right
      setTransform(img1Ref, -1.3, -1.1, -12); // Slightly more inward
      setTransform(img2Ref, 1.3, -1.1, 15);
      setTransform(img3Ref, -1.3, 1.1, -10);
      setTransform(img4Ref, 1.3, 1.1, 8);
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Initial call
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section className="about-section" ref={sectionRef}>
      <div className="sticky-wrapper">
        <div className="about-container container">
            {/* Floating Images (Corners) */}
            <div className="about-image img-top-left" ref={img1Ref}>
                <img src={optimizeImage(about1, { width: 280, height: 210 })} alt="Pet Care" loading="lazy" width="280" height="210" />
            </div>
            <div className="about-image img-top-right" ref={img2Ref}>
                <img src={optimizeImage(about2, { width: 280, height: 210 })} alt="Pet Nutrition" loading="lazy" width="280" height="210" />
            </div>
            <div className="about-image img-bottom-left" ref={img3Ref}>
                <img src={optimizeImage(about3, { width: 280, height: 210 })} alt="Expert Formulation" loading="lazy" width="280" height="210" />
            </div>
            <div className="about-image img-bottom-right" ref={img4Ref}>
                <img src={optimizeImage(about4, { width: 280, height: 210 })} alt="Pet Health" loading="lazy" width="280" height="210" />
            </div>

            {/* Central Content */}
            <div className="about-content">
                <h2 className="about-title">
                    We Care For Your Pets Like<br />
                    Family, With Premium Nutrition<br />
                    And Expert Formulation
                </h2>
                <div className="about-cta">
                    <Link to="/about" className="btn-about">About Us</Link>
                </div>
            </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
